var map = {
	"./pr-1.png": "9dda",
	"./pr-2.png": "f76d",
	"./pr-3.png": "17de",
	"./pr-4.png": "6d39",
	"./pr-5.png": "f92c",
	"./pr-6.png": "72b2",
	"./pr-7.png": "7e5e",
	"./pr-8.png": "c8a2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b455";